// extracted by css-extract-rspack-plugin
module.exports =  {"label":"ChargeOrRefundDialog__label___E9PZf"};